module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-146.78afd1fb.svg";